import { type AppContext } from 'next/app'
import { type GetAuth } from '@stuller/stullercom/feat/auth'
import { isUnauthenticatedPath } from './isUnauthenticatedPath'
import type { StatusCodeProps } from '@stuller/stullercom/feat/layout-context'

const FORCE_CHANGE_PASSWORD_PATH = '/forcechangepassword'

/**
 * Redirects the user to the force change password page if they need to change their password
 */
function getResetPasswordRedirect (appContext: AppContext, auth: GetAuth): StatusCodeProps | null {
  const { ctx } = appContext
  const { authUser, isStullerComShowcaseMode } = auth

  if (authUser?.user?.resetPassword === true &&
    !isStullerComShowcaseMode &&
    authUser?.consultantLogin == null &&
    authUser?.impersonatedBy == null &&
    !isUnauthenticatedPath(ctx.asPath)) {
    return { statusCode: 302, location: FORCE_CHANGE_PASSWORD_PATH }
  }

  return null
}

export {
  getResetPasswordRedirect,
  FORCE_CHANGE_PASSWORD_PATH
}
